module.exports = __webpack_public_path__ + "img/no_data_statuspng.7625a88f.png";